import jQuery from 'jquery';

const Drupal = window.Drupal;
const once = window.once;

(function(jQuery, Drupal) {
  'use strict';

  const mobileBreakpoint = 992;
  let $openMenuItem = null;

  function registerClickElsewhereHandler($menuItem) {
    if (!isMobile()) {
      jQuery(document).click(function(event) {
        // if the target of the click isn't the container nor a descendant of the container
        if ($openMenuItem instanceof jQuery && !$openMenuItem.is(event.target) && $openMenuItem.has(event.target).length === 0) {
          $openMenuItem.removeClass('open');
          $openMenuItem = null;
          jQuery(document).off('click');
        }
      });
    }
  }

  function isMobile() {
    return jQuery(window).innerWidth() < mobileBreakpoint;
  }

  Drupal.behaviors.menuToggle = {
    attach: function(context, settings) {
      const $navContainer = jQuery('.site-nav', context);

      once('menu-toggle', $navContainer).forEach(function(element) {
        let $self = jQuery(element);
        let $navMenu = jQuery('.menu--main > ul.menu', $self);
        let $navToggle = jQuery('.menu-toggle', $self);
        let $menuItemsWithDropdown = jQuery('> li.menu-item--has-dropdown', $navMenu);

        $navToggle.click(function() {
          jQuery(this).toggleClass('is-active');
          $navMenu.toggleClass('open');
        });

        $menuItemsWithDropdown.each(function() {
          let $thisMenuItem = jQuery(this);
          let $thisMenuItemLink = jQuery('> a', $thisMenuItem);

          $thisMenuItemLink.click(function(event) {
            event.preventDefault();
            event.stopPropagation();

            if ($openMenuItem instanceof jQuery) {
              $openMenuItem.removeClass('open');

              if ($thisMenuItem === $openMenuItem) {
                $openMenuItem = null;
                return;
              }
            }

            $openMenuItem = $thisMenuItem;
            $openMenuItem.addClass('open');
            registerClickElsewhereHandler($thisMenuItem);
          });
        });
      });
    }
  };

})(jQuery, Drupal);
